import axios from 'axios'

axios.defaults.baseURL = 'https://api-crm.autopilot.io'
// axios.defaults.baseURL = 'http://localhost:5000'

// axios.defaults.withCredentials = true;

export default axios


// WEBPACK FOOTER //
// ./src/utils/axios.js